import axios from 'axios';
import router from '@/router'

axios.interceptors.response.use(undefined, function (error) {
  if (error.response.status >= 400 && error.response.status < 500 && window.location.pathname !== "/login") {
    router.push({name: 'Login'})
  }
  // error.handleGlobally = errorComposer(error);
  return Promise.reject(error);
});

export default axios
